/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import * as React from "react";
import { CompoundButton } from "@fluentui/react/lib/Button";
import { ISettingGroupDefinition } from "@nuance/hierarchical-settings-ui-domain";
import { saveSettingsDefinitionFile } from "../Utilities/FileOperations";
import { getLogger, ILogger } from "@nuance/hux-diagnostics";

const logger: ILogger = getLogger();

/**
 * Properties for ViewActions
 */
interface IViewActionsProps {
    definition?: ISettingGroupDefinition;
}

/**
 * ViewActions component
 *
 * @param props ViewActions properties
 * @returns Rendered view actions
 */
const ViewActions = (props: IViewActionsProps): JSX.Element => {
    /**
     * Saves the setting definition to disk
     */
    const saveDefinition = async () => {
        if (props.definition !== undefined) {
            logger.trackEvent("Save definition to file", {
                definitionName: props.definition.SettingGroupName
            });
            await saveSettingsDefinitionFile(props.definition);
        }
    };

    return (
        <nav>
            <CompoundButton
                iconProps={{ iconName: "Download" }}
                primary
                secondaryText="Save settings definition as JSON."
                onClick={saveDefinition}
            >
                Export definition
            </CompoundButton>
        </nav>
    );
};
export default ViewActions;
